import { isUpcomingAppointment } from '@avanta/shared/utils/appointments';
import { useMemo } from 'react';
import { useFetchEnterpriseAppointments } from 'pages/Appointments/useFetchEnterpriseAppointments';
import { type AppointmentWithDetails } from 'types/appointments';

export const usePatientsAppointmentSummary = (): {
  appointmentsByPatientId: Map<string, AppointmentWithDetails>;
  withSession: number;
  isLoading: boolean;
  isError: boolean;
} => {
  const { data: appointments = [], isLoading, isError } = useFetchEnterpriseAppointments();

  const appointmentsByPatientId = useMemo(
    () =>
      appointments.filter(isUpcomingAppointment).reduce((summary, appointment) => {
        const currentAppointment = summary.get(appointment.patientId);

        if (
          !currentAppointment ||
          new Date(appointment.dateTime).getTime() < new Date(currentAppointment.dateTime).getTime()
        ) {
          summary.set(appointment.patientId, appointment);
        }

        return summary;
      }, new Map<string, AppointmentWithDetails>()),
    [appointments]
  );

  return { appointmentsByPatientId, withSession: appointmentsByPatientId.size, isLoading, isError };
};
